import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const faqs = [
    {
      q: '韩漫之家的漫画都是免费的吗？',
      a: '是的，韩漫之家所有漫画均免费提供在线阅读，无需付费即可享受最新高清韩国漫画，是您值得信赖的免费韩漫平台。',
    },
    {
      q: '漫画更新频率如何？',
      a: '我们每日更新超过200话内容，与韩国原版保持同步更新节奏，确保您第一时间阅读到最新章节。',
    },
    {
      q: '支持手机阅读吗？',
      a: '当然支持！韩漫之家网站采用响应式设计，完美适配手机、平板和电脑等各种设备，随时随地畅享韩漫阅读体验。',
    },
    {
      q: '如何找到我想看的漫画？',
      a: '您可以通过首页的分类导航按类型浏览，也可以使用搜索功能查找特定作品。我们还提供人气排行榜帮助您发现热门韩漫。',
    },
    {
      q: '漫画画质如何？',
      a: '韩漫之家坚持提供高清画质漫画，所有作品均以最佳分辨率呈现，让您欣赏到最精美的韩国漫画画面细节。',
    },
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: '品牌信誉',
      desc: '韩漫之家深耕韩漫领域多年，以优质内容和稳定服务赢得百万读者信赖，是业内公认的可靠韩漫阅读平台。',
    },
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      desc: '我们坚持提供最高清画质的漫画作品，每一页都经过精心优化，确保读者获得极致的视觉阅读体验。',
    },
    {
      icon: 'ri-timer-flash-line',
      title: '实时更新',
      desc: '与韩国原版同步更新，第一时间为中文读者带来最新韩漫章节，绝不让您错过任何精彩内容。',
    },
    {
      icon: 'ri-shield-star-line',
      title: '免费阅读',
      desc: '所有漫画作品均免费开放，无隐藏收费、无广告打扰，纯粹的漫画阅读体验始终是我们的承诺。',
    },
  ];

  const stats = [
    { value: '5,800+', label: '收录韩漫' },
    { value: '200万+', label: '注册用户' },
    { value: '3.8亿+', label: '累计阅读' },
    { value: '99.7%', label: '用户好评率' },
  ];

  const pageTitle = '关于韩漫之家 - 品牌介绍与联系我们';
  const pageDesc = '韩漫之家提供漫画免费韩漫服务，最新高清免费韩国漫画大全与热门韩漫作品均可在线阅读。了解我们的品牌故事、平台优势及联系方式。';

  return (
    <>
      <Navbar />
      <main>
        <div className="hidden">
          <meta data-page-title={pageTitle} />
        </div>

        <section className="pt-20 md:pt-24 bg-accent-50">
          <div className="px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-foreground-400 text-xs mb-8" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
                <span className="text-foreground-700 font-medium">关于我们</span>
              </nav>

              <div className="text-center mb-12">
                <span className="inline-block bg-white/80 text-foreground-700 text-xs font-medium px-4 py-1.5 rounded-full whitespace-nowrap">
                  关于我们
                </span>
                <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-4">
                  致力于成为最好的<br />
                  <span className="text-foreground-500 font-light">韩漫在线阅读平台</span>
                </h1>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
                {stats.map((stat, idx) => (
                  <div key={idx} className="flex flex-col items-center gap-2">
                    <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
                      {stat.value}
                    </span>
                    <p className="text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="text-xs text-foreground-400 tracking-wider uppercase">平台优势</span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                  为什么选择韩漫之家
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {values.map((v, idx) => (
                  <div key={idx} className="bg-background-100 rounded-lg p-6 flex flex-col gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-foreground-900 rounded-lg">
                      <i className={`${v.icon} text-lg text-background-50`}></i>
                    </span>
                    <h3 className="text-base font-bold text-foreground-900">{v.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 items-center">
                <div className="w-full lg:w-[40%]">
                  <div className="rounded-lg overflow-hidden bg-accent-100 aspect-[4/5]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20editorial%20illustration%20warm%20cozy%20reading%20scene%20person%20reading%20comics%20on%20tablet%20in%20cafe%20with%20bookshelf%20background%20soft%20cream%20and%20beige%20tones%20professional%20art%20style%20clean%20composition%20gentle%20warmth&width=800&height=1000&seq=about-founder-hanman&orientation=portrait"
                      alt="韩漫之家创始团队"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="flex-1 flex flex-col gap-5">
                  <span className="text-xs text-secondary-500 tracking-wider">&ldquo;我们的故事&rdquo;</span>
                  <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight">
                    从热爱韩漫开始，<br />
                    <span className="text-foreground-300 font-light">到服务百万读者</span>
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed bg-background-50 rounded-lg p-5">
                    &ldquo;韩漫之家创立于对韩国漫画的深深热爱。我们的创始团队是一群资深的韩漫读者，深知中文读者在寻找高质量韩漫时的困难——语言障碍、更新滞后、画质模糊。因此，我们决心打造一个专业、高效的韩漫在线阅读平台，让每一位中文读者都能轻松享受最新、最高清的韩国漫画。经过多年的努力，韩漫之家已成长为拥有超过200万注册用户、收录5800余部韩漫作品的行业领先平台。我们始终坚守初心：免费、高清、及时更新。&rdquo;
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="w-6 h-px bg-foreground-300"></span>
                    <span className="text-sm font-bold text-foreground-900">韩漫之家创始团队</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="text-xs text-foreground-400 tracking-wider uppercase">常见问题</span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                  读者关心的常见问题
                </h2>
              </div>

              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {faqs.map((faq, idx) => (
                  <div key={idx} className="bg-background-100 rounded-lg overflow-hidden">
                    <button
                      onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                      className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                    >
                      <h3 className="text-sm font-bold text-foreground-900 pr-4">{faq.q}</h3>
                      <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform ${activeFaq === idx ? 'rotate-180' : ''}`}>
                        <i className="ri-arrow-down-s-line text-foreground-500"></i>
                      </span>
                    </button>
                    {activeFaq === idx && (
                      <div className="px-5 pb-5">
                        <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <span className="text-xs text-foreground-400 tracking-wider uppercase">联系我们</span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                  与韩漫之家取得联系
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto">
                <div className="flex flex-col gap-6">
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900 mb-1">电子邮箱</p>
                      <a href="mailto:hello@guanlist.com" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">hello@guanlist.com</a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full flex-shrink-0">
                      <i className="ri-phone-line text-accent-600 text-lg"></i>
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900 mb-1">客服电话</p>
                      <p className="text-sm text-foreground-500">400-888-韩漫（4266）</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-full flex-shrink-0">
                      <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900 mb-1">公司地址</p>
                      <p className="text-sm text-foreground-500">北京市朝阳区望京SOHO T3·A座2208室</p>
                    </div>
                  </div>
                </div>

                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: pageTitle,
            description: pageDesc,
            url: 'http://guanlist.com/about',
            about: {
              '@type': 'Organization',
              name: '韩漫之家',
              description: '韩漫之家是一个专注于韩国漫画在线阅读的中文平台，提供最新高清免费韩国漫画大全。',
              url: 'http://guanlist.com/',
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '+86-400-888-4266',
                contactType: 'customer service',
                availableLanguage: ['Chinese'],
              },
              address: {
                '@type': 'PostalAddress',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                streetAddress: '望京SOHO T3·A座2208室',
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'http://guanlist.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
    </>
  );
}

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone_alt: '',
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const honeypot = (e.target as HTMLFormElement).querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setFormData({ name: '', email: '', message: '', phone_alt: '' });
      return;
    }

    setStatus('loading');
    setFormError('');

    try {
      const form = e.currentTarget as HTMLFormElement;
      const payload = new FormData(form);
      payload.delete('phone_alt');

      const response = await fetch('http://guanlist.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = (
        (parsed?.meta as Record<string, string>)?.message ||
        (parsed?.message as string) ||
        (parsed?.meta as Record<string, string>)?.detail ||
        responseText
      );

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setFormData({ name: '', email: '', message: '', phone_alt: '' });
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4" id="contact-form-about">
      <input
        type="text"
        name="name"
        placeholder="您的姓名"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        className="bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors"
        required
      />
      <input
        type="email"
        name="email"
        placeholder="您的邮箱"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        className="bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors"
        required
      />
      <textarea
        name="message"
        placeholder="请输入您的留言内容..."
        value={formData.message}
        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        rows={4}
        maxLength={500}
        className="bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors resize-none"
        required
      ></textarea>
      <input
        type="text"
        name="phone_alt"
        value={formData.phone_alt}
        onChange={(e) => setFormData({ ...formData, phone_alt: e.target.value })}
        className="form-hp-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly={false}
      />
      <button
        type="submit"
        disabled={status === 'loading'}
        className="bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 text-sm font-medium px-6 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
      >
        {status === 'loading' ? '发送中...' : '发送留言'}
      </button>
      {status === 'success' && (
        <p className="text-xs text-accent-600">感谢您的留言，我们会尽快回复！</p>
      )}
      {status === 'error' && (
        <p className="text-xs text-primary-600">{formError || '提交失败，请稍后重试'}</p>
      )}
    </form>
  );
}